export default {
  filterAlarmsButtonLabel: 'Störungen filtern',
  filterTimeBucketLabel: 'Granularität',
  paretoOccurrences: 'Pareto: Häufigkeit',
  paretoDuration: 'Pareto: Störungsdauer',
  table: 'Störungsstatistik',
  gantt: 'Zeitlicher Verlauf',
};
